module.exports = __webpack_public_path__ + "img/locker_no_compartment.5341e1d5.svg";